import {AfterViewInit, Component, OnDestroy, OnInit, Renderer2, ViewChild} from '@angular/core';
import DataSource from 'devextreme/data/data_source';
import ArrayStore from 'devextreme/data/array_store';
import {UserDomainService} from '../user-domains/user-domain.service';
import {notify, Poi, User} from 'shared';
import {PoiService} from '../stores/poi.service';
import {UserDomain} from '../user-domains/user-domain';
import {Subject, Subscription, zip} from 'rxjs';
import polygonIcon from '@iconify/icons-mdi/vector-polygon';
import pointIcon from '@iconify/icons-mdi/map-marker-radius-outline';
import folderIcon from '@iconify/icons-mdi/folder-outline';
import {DxDataGridComponent, DxTextBoxComponent} from 'devextreme-angular';
import {
  Circle,
  CircleMarker,
  Control,
  DrawEvents,
  featureGroup,
  FeatureGroup,
  LatLngExpression,
  Map,
  Marker,
  Polygon,
  Polyline,
  Rectangle
} from 'leaflet';
import {MapService} from '../services/map.service';
import {debounceTime, filter, first} from 'rxjs/operators';
import * as L from 'leaflet';
import {DxoFormComponent} from 'devextreme-angular/ui/nested';
import {PoiCategoryService} from '../stores/poi-category.service';
import * as geojson from 'geojson';
import {NgElement, WithProperties} from '@angular/elements';
import {MapFieldPopupComponent} from '../map-fields/map-field-popup/map-field-popup.component';
import {MapPoiPopupComponent} from './map-poi-popup/map-poi-popup.component';
import {MapSidebarFilterService} from '../map/map-sidebar-filter/map-sidebar-filter.service';
import {MapSidebarFilter} from '../map/map-sidebar-filter/map-sidebar-filter';

@Component({
  selector: 'app-map-poi',
  templateUrl: './map-poi.component.html',
  styleUrls: ['./map-poi.component.scss']
})
export class MapPoiComponent implements OnInit, AfterViewInit, OnDestroy {
  ds: DataSource;
  catDs: DataSource;
  catDsLookup: DataSource;

  polygonIcon = polygonIcon;
  pointIcon = pointIcon;
  folderIcon = folderIcon;

  canEdit: boolean;
  canAdd: boolean;
  canDelete: boolean;
  listGrouped: boolean;
  listSearchEnabled = false;
  domainChangeSub: Subscription;

  @ViewChild(DxDataGridComponent)
  grid: DxDataGridComponent;
  gridSaveBtn: HTMLElement;
  gridCancelBtn: HTMLElement;

  @ViewChild(DxoFormComponent)
  form: DxoFormComponent;

  @ViewChild(DxTextBoxComponent)
  searchTxtBox: DxTextBoxComponent;

  alignments = [
    {value: 'marker', name: 'Place', icon: `<svg  width="18px" height="18px" viewBox="0 0 24 24">${pointIcon.body}</svg>`},
    {value: 'polygon', name: 'Zone', icon: `<svg  width="18px" height="18px" viewBox="0 0 24 24">${polygonIcon.body}</svg>`},
  ];

  editMenu = [
    {value: 'edit', name: 'Editer', icon: 'edit'},
    {value: 'delete', name: 'Supprimer', icon: 'trash'},
    {value: 'fit', name: 'Visiter', icon: 'map'},
  ];

  currentRowIndex: number;
  currentPoiIsNew: boolean;
  currentPoi: Poi;
  // Saved as old geo in case of cancel editing
  currentPoiGeojson: any;

  public map: Map;
  drawControl: L.Control.Draw;
  drawingInit: L.Draw.Feature;
  drawing: Circle | CircleMarker | Marker | Polygon | Polyline | Rectangle;
  editableMapLayer: FeatureGroup = featureGroup();
  addPoiBtnDisabled = true;
  catPopupVisible: boolean;
  editSelectCategoryDisabled: boolean;

  groupExpanded = false;
  groupToggleIcon: string = this.groupExpanded ? 'collapse' : 'expand';
  private sideFilterSub: Subscription;

  dsLoadChanged$ = new Subject<void>();
  currentCell: any;
  contextMenuTarget: any;
  contextMenuVisible: boolean;

  constructor(
    private poiService: PoiService,
    private poiCategoryService: PoiCategoryService,
    private userDomainsService: UserDomainService,
    private mapService: MapService,
    private renderer: Renderer2,
    private mapSidebarFilter: MapSidebarFilterService,
    public user: User
  ) {

    // Create a local store from remote one
    // this.createLocalStore();
    this.ds = this.poiService.newDataSource({
      paginate: false,
      pageSize: 100000,
      onLoadingChanged: (isLoading) => {
        if (!isLoading) {
          this.dsLoadChanged$.next();
          this.updateMap();
        }
      }
    }, true);
    this.catDs = this.poiCategoryService.newDataSource({
      onLoadingChanged: (isLoading) => {
        if (!isLoading) {
          this.fetchCategories();
        }
      },
    });
    this.fetchCategories();

    // Permissions
    this.canEdit = user.can('edit fields');
    this.canAdd = user.can('add fields');
    this.canDelete = user.can('delete fields');

    // Wait map ready
    this.mapService.mapReady$.pipe(first()).subscribe((map) => {
      this.map = map;


      map.addLayer(this.editableMapLayer);
      this.drawControl = new Control.Draw({
        draw: null,
        edit: {
          featureGroup: this.editableMapLayer,
          edit: false,
          remove: false,
        }
      });
      map.addControl(this.drawControl);

      map.addEventListener(L.Draw.Event.CREATED, (e: DrawEvents.Created) => {
        this.editableMapLayer.addLayer(e.layer);
        this.drawing = e.layer;
        // @ts-ignore
        this.drawing.editing.enable();
        this.currentPoi.geojson = this.drawing.toGeoJSON().geometry;
      });

      map.addEventListener(L.Draw.Event.EDITVERTEX, (e: DrawEvents.EditVertex) => {
        this.drawing = e.poly;
        this.currentPoi.geojson = this.drawing.toGeoJSON().geometry;
        if (!this.currentPoiIsNew && this.currentRowIndex) {
          this.grid.instance.cellValue(this.currentRowIndex, 'geometry', this.currentPoi.geometry);
        }
      });

      map.addEventListener(L.Draw.Event.EDITMOVE, (e: DrawEvents.EditMove) => {
        // @ts-ignore
        this.drawing = e.layer;
        this.currentPoi.geojson = this.drawing.toGeoJSON().geometry;
        if (!this.currentPoiIsNew && this.currentRowIndex) {
          this.grid.instance.cellValue(this.currentRowIndex, 'geometry', this.currentPoi.geometry);
        }
      });

      // Enable add
      this.addPoiBtnDisabled = false;
    });

    // Bindings
    this.toggleSearch = this.toggleSearch.bind(this);
    this.startDraw = this.startDraw.bind(this);
    this.showCategoriesPopup = this.showCategoriesPopup.bind(this);
    this.editSelectedDomainChange = this.editSelectedDomainChange.bind(this);
    this.cancelEditing = this.cancelEditing.bind(this);
    this.groupsToggle = this.groupsToggle.bind(this);
    this.filterClick = this.filterClick.bind(this);
  }

  ngOnInit() {
  }

  ngAfterViewInit(): void {
    // Defer rendering
    this.grid.instance.option('dataSource', this.ds);

    // Sidebar filter
    this.sideFilterSub = this.mapSidebarFilter.filter$.subscribe(() => {
      // Update map
      zip(
        this.dsLoadChanged$,
        this.mapService.mapReady$,
        this.grid.onOptionChanged.pipe(
          filter(o => o.name === 'columns'),
          debounceTime(200),
        )
      ).pipe(
        first()
      ).subscribe(() => {
        this.updateMap();
      });
      this.mapSidebarFilter.applyOnGrid(this.grid.instance);
    });
  }

  updateMap() {
    this.editableMapLayer.clearLayers();
    this.updateMapList(this.ds.items());
    /*this.ds.items().forEach((domain) => {
      if (!domain.items) {
        return;
      }
      domain.items.forEach((category) => {
        if (!category.items) {
          return;
        }
        category.items.forEach((poi: Poi) => {

          const layer = poi.layer;

          let popupEl: NgElement & WithProperties<MapPoiPopupComponent> = null;
          layer.bindPopup(() => {
            if (popupEl === null) {
              popupEl = document.createElement('poi-popup') as any;
            }
            popupEl.poi = poi;
            popupEl.gridDs = this.ds;
            popupEl.startDrawing = (p: Poi) => {
              this.currentPoi = p;
            };
            return popupEl;
          }, {
            offset: [0, -30],
            minWidth: 450,
            maxWidth: 450,
            className: 'field-poi-popup',
          });

          layer.bindTooltip(poi.name, {
            direction: poi.type === 'POLYGON' ? 'center' : 'top',
            offset: [0, -40],
            opacity: 0.8,
          });

          this.editableMapLayer.addLayer(layer);
        });
      });
    });*/
  }

  updateMapList(list) {
    if (!list) {
      return;
    }

    list.forEach(poi => {
      if (poi.hasOwnProperty('items')) {
        this.updateMapList(poi.items);
      } else {
        const layer = poi.layer;

        let popupEl: NgElement & WithProperties<MapPoiPopupComponent> = null;
        layer.bindPopup(() => {
          if (popupEl === null) {
            popupEl = document.createElement('poi-popup') as any;
          }
          popupEl.poi = poi;
          popupEl.gridDs = this.ds;
          popupEl.startDrawing = (p: Poi) => {
            this.currentPoi = p;
          };
          return popupEl;
        }, {
          offset: [0, -30],
          minWidth: 450,
          maxWidth: 450,
          className: 'field-poi-popup',
        });

        layer.bindTooltip(poi.name, {
          direction: poi.type === 'POLYGON' ? 'center' : 'top',
          offset: [0, -40],
          opacity: 0.8,
        });

        this.editableMapLayer.addLayer(layer);
      }
    });
  }

  private async fetchCategories() {
    const remoteDs = this.poiCategoryService.newDataSource({
      paginate: false,
    });

    // Data source
    this.catDsLookup = new DataSource({
      paginate: false,
      store: new ArrayStore({
        key: 'id',
        data: await remoteDs.load(),
      }),
    });
  }

  toggleSearch(e: any) {
    this.searchTxtBox.instance.focus();
    // this.listSearchEnabled = !this.listSearchEnabled;
  }

  onToolbarPreparing(e: any) {
    const toolbarItems = e.toolbarOptions.items;

    toolbarItems.forEach((item) => {
      if (item.name === 'searchPanel') {
        item.location = 'before';
      }
    });
  }

  onGridContentReady(e: any) {
    e.element.querySelector('colgroup')?.remove();
    e.element.querySelectorAll('tbody > tr').forEach((node) => {
      const td = node.getElementsByTagName('td');
      while (td.length > 1) {
        td[0].remove();
      }
      td[0].removeAttribute('colspan');
    });
    const btns = e.element.querySelectorAll('.dx-datagrid-form-buttons-container > div');
    if (!btns.length) {
      [this.gridSaveBtn, this.gridCancelBtn] = [null, null];
      return;
    }
    [this.gridSaveBtn, this.gridCancelBtn] = btns;
    this.renderer.listen(this.gridCancelBtn, 'click', (ev) => {
      this.cancelEditing();
    });
  }

  private cancelEditing() {
    if (this.currentPoiIsNew) {
      this.drawingInit.disable();
      this.drawing.remove();
    } else {
      // @ts-ignore
      this.currentPoi.layer.editing.disable();
      this.currentPoi.layer.remove();
      this.currentPoi.geojson = this.currentPoiGeojson;
      this.currentPoi.layer = this.currentPoi.cloneLayer();
      this.currentPoi.layer.addTo(this.map);
    }
  }

  onGridInitNewRow(e: any) {
    this.currentPoi = new Poi(e.data);
    this.currentRowIndex = 0;
    this.currentPoiIsNew = true;
    this.editSelectCategoryDisabled = true;
  }

  onGridRowInserting(e: any) {
    if (!this.currentPoi.geometry) {
      notify('Merci de déssiner la zone sur la carte.', 'warning');
      e.cancel = true;
    }
    e.data = Object.assign(e.data, this.currentPoi);
  }

  onGridRowInserted(e: any) {
  }

  onGridEditingStart(e: any) {
    this.currentPoi = e.data;
    this.currentPoiIsNew = false;
    this.currentPoiGeojson = this.currentPoi.geojson;

    this.editSelectCategoryDisabled = true;
    this.catDsLookup.filter(['domain_id', '=', this.currentPoi.domain_id]);
    this.catDsLookup.reload().then(() => {
      this.editSelectCategoryDisabled = false;
    });

    // @ts-ignore
    this.currentPoi.layer.editing.enable();
    this.map.fitBounds(this.currentPoi.getBounds());
  }

  onGridRowUpdating(e: any) {
    if (!this.currentPoi.geometry) {
      notify('Merci de déssiner la zone sur la carte.', 'warning');
      e.cancel = true;
    }
  }

  onGridRowUpdated(e: any) {

  }

  onGridRowRemoved(e: any) {

  }

  searchGrid(e: any) {
    this.grid.instance.searchByText(e.value);
  }

  edit(e: any, cell: any) {
    this.grid.instance.editRow(cell.rowIndex);
    this.currentRowIndex = cell.rowIndex;
  }

  remove(e: any, cell: any) {
    this.grid.instance.deleteRow(cell.rowIndex);
    // this.currentRowIndex = cell.rowIndex;
  }

  editSelectedDomainChange(e: number, cellInfo: any) {
    cellInfo.setValue(e);
    this.editSelectCategoryDisabled = true;
    this.catDsLookup.filter(['domain_id', '=', e]);
    this.catDsLookup.reload().then(() => {
      this.editSelectCategoryDisabled = false;
    });
  }

  startDraw(e: any) {
    switch (e.itemData.value) {
      case 'polygon':
        // @ts-ignore
        this.drawingInit = (new L.Draw.Polygon(this.map, {
          drawError: {
            color: '#24d200', // Color the shape will turn when intersects
            message: '<strong>Oh snap!<strong> you can\'t draw that!' // Message that will show when intersect
          },
          shapeOptions: {
            weight: 1,
            color: '#1a8b00'
          }
        }));
        this.drawingInit.enable();
        this.grid.instance.addRow().then(() => {
          this.currentPoi.type = 'POLYGON';
        });
        break;
      case 'marker':
        // @ts-ignore
        const redMarker = L.ExtraMarkers.icon({
          icon: 'fa-plus',
          markerColor: 'green-light',
          prefix: 'fas'
        });
        // @ts-ignore
        this.drawingInit = (new L.Draw.Marker(this.map, {
          icon: redMarker,
        }));
        this.drawingInit.enable();
        this.grid.instance.addRow().then(() => {
          this.currentPoi.type = 'POINT';
        });
        break;
    }
  }

  showCategoriesPopup(e: any) {
    this.catPopupVisible = true;
  }

  groupsToggle(e: any) {
    if (this.groupExpanded) {
      this.grid.instance.collapseAll();
      this.groupExpanded = false;
      this.groupToggleIcon = 'expand';
    } else {
      this.grid.instance.expandAll();
      this.groupExpanded = true;
      this.groupToggleIcon = 'collapse';
    }
  }


  editMenuBtnClick(e: any) {
    e.event.stopImmediatePropagation();
  }

  editMenuClick(e: any) {

    switch (e.itemData.value) {
      case 'edit':
        this.edit(e, this.currentCell);
        break;
      case 'delete':
        this.remove(e, this.currentCell);
        break;
      case 'fit':
        this.map.fitBounds(this.currentCell.data.getBounds());
        break;
    }
  }

  onRowClick(e: any) {
    if (e.rowType === 'group') {
      return;
    }
    this.map.fitBounds(e.data.getBounds());
  }

  filterClick = () => {
    this.mapSidebarFilter.show();
  }

  ngOnDestroy(): void {
    this.sideFilterSub.unsubscribe();
  }

  refreshGrid = (e: any) => {
    this.grid.instance.refresh();
  }

  showContextMenu(e: any, cell) {
    this.currentCell = cell;
    (e.event as MouseEvent).stopPropagation();
    this.contextMenuTarget = e.element;
    this.contextMenuVisible = true;
  }
}
